import { render } from "./LinkText.vue?vue&type=template&id=15869376&scoped=true"
import script from "./LinkText.vue?vue&type=script&lang=js"
export * from "./LinkText.vue?vue&type=script&lang=js"

import "./LinkText.vue?vue&type=style&index=0&id=15869376&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15869376"]])

export default __exports__